import React, { FC, ReactNode, Children } from 'react';
import styled from '@emotion/styled';
import { rem } from 'polished';
import { css } from '@emotion/react';
import flattenChildren from 'react-keyed-flatten-children';
import { mixins, spaces, spacingCurves } from '../../core/styles/theme/default';
import { getSpaceOrCurve } from '../../core/utils/Utils';
import { SpaceInterface } from '../../types';

const StyledStack: any = styled.div``;

const StyledStackItem: any = styled.div(
  ({ index, staticSpace, spacingCurve }: any) => {
    return index > 0
      ? css`
          ${staticSpace &&
          css`
            padding-top: ${rem(spaces[staticSpace])};
          `}

          ${spacingCurve &&
          css`
            ${mixins.responsiveStyles(
              spacingCurves.component[spacingCurve]('padding-top'),
            )}
          `}
        `
      : 0;
  },
);

const Stack: FC<StackProps> = ({
  component = 'div',
  space = 'hecto',
  children,
  ...rest
}: StackProps) => {
  const stackItems = flattenChildren(children);
  const isList = component === 'ol' || component === 'ul';
  const stackItemComponent = isList ? 'li' : 'div';
  const spaceType = getSpaceOrCurve(space);

  return (
    <StyledStack as={component} {...rest}>
      {Children.map(stackItems, (child, index) => {
        return (
          <StyledStackItem index={index} as={stackItemComponent} {...spaceType}>
            {child}
          </StyledStackItem>
        );
      })}
    </StyledStack>
  );
};

export type StackProps = {
  /** Component which wraps the Stack Item */
  component?: string;
  /** SpacingCurve Name for space between Stack Items */
  space?: SpaceInterface;
  /** Children of the Stack */
  children?: ReactNode;
};

export default Stack;
